<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
    <path
      :fill="color"
      d="M8.787.048c.135-.064.291-.064.426 0l8.5 4c.383.18.383.724 0 .904L14.424 6.5l3.289 1.549c.353.166.38.643.081.857l-.081.047L13.36 11l4.352 2.048c.353.166.38.643.081.857l-.081.047-8.5 4c-.108.051-.23.061-.343.03l-.083-.03-8.5-4c-.353-.166-.38-.643-.081-.857l.081-.047 4.351-2.049-4.35-2.047c-.354-.166-.381-.643-.082-.857l.081-.047 3.288-1.549L.287 4.952c-.353-.166-.38-.643-.081-.857l.081-.047zm3.399 11.504l-2.973 1.4c-.108.051-.23.061-.343.03l-.083-.03-2.975-1.4-4.138 1.947 7.325 3.448 7.326-3.447-4.139-1.948zm1.063-4.5l-4.036 1.9c-.135.064-.291.064-.426 0l-4.037-1.9L1.674 8.5l7.325 3.447 7.326-3.448-3.076-1.447zM9 1.052L1.674 4.5 4.75 5.947l.066-.03.036.078 4.147 1.952 7.326-3.448L9 1.052z"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>
